import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Modal } from 'apps/modals/views/modal';
import SelectSubtemplateContent from 'apps/readme/views/selectSubtemplateContent';

import { ModalTitle, Divider } from 'legacyComponents/styled/lib';

@observer
export class SelectSubtemplateParentModal extends Modal {
  /* When the user selects one of the user journeys, 
     we must keep all the previously added subsections 
     while adding the associated with that journey */

  render() {
    return (
      <div>
        <SelectSubtemplateTitle>
          {'Select the sections to import'}
        </SelectSubtemplateTitle>
        <Divider />
        <SelectSubtemplateContent
          subsections={this.props.subsections}
          userJourneysData={this.props.userJourneysData}
          clickConfirm={this.props.clickConfirm}
          clickCancel={this.props.clickCancel}
          filledSections={this.props.filledSections}
        />
      </div>
    );
  }
}

SelectSubtemplateParentModal.propTypes = {
  subsections: PropTypes.object,
  userJourneysData: PropTypes.object,
  clickConfirm: PropTypes.func,
  clickCancel: PropTypes.func,
  filledSections: PropTypes.array,
};

const SelectSubtemplateTitle = styled(ModalTitle)`
  font-family: HelveticaNowDisplay;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 126%;
`;
